import { i18nextT } from "../../../hooks/i18n/i18n";

import type { HostingStyleMap } from "utility/hosting";

export const event1BaseStyles = (): HostingStyleMap => {
  return {
    baseStyles: {
      baseColor: "#000",
      mainColor: "#000",
      accentColor: "#00c2ae",
      fontPrimaryColor: "#fff",
      fontSecondaryColor: "#000",
      backgroundImage: null,
    },

    commonSettings: {
      auth: {
        loginMethod: {
          twitter: true,
          facebook: false,
        },
      },
      route: {
        home: "/",
      },
      meta: {
        favicon: null,
        appleTouchIcon: null,
        title: null,
        description: null,
        copyright: i18nextT("hosting.templates.event1.footer.copyright"),
      },
      header: {
        logo: {
          isDisplay: false,
          path: null,
        },
        textColor: "#fff",
        svgColor: "#fff",
      },
      menu: {
        home: {
          isDisplay: true,
        },
        event: {
          isDisplay: true,
          text: i18nextT("hosting.templates.event1.common.section.event.name"),
        },
        archive: {
          isDisplay: true,
          text: i18nextT(
            "hosting.templates.event1.common.section.archive.name"
          ),
        },
        account: {
          isDisplay: true,
        },
        pastEvents: {
          isDisplay: true,
          text: i18nextT(
            "hosting.templates.event1.common.section.pastEvents.name"
          ),
        },
        eventNotes: {
          isDisplay: true,
          path: null,
        },
        guide: {
          isDisplay: true,
        },
        contact: {
          isDisplay: true,
          path: null, // if use other event notes url. null is default.
        },
      },
      isDisplayBreadcrumb: true,
      isDisplayEventDate: true,
      isDisplayEventTime: true,
    },

    pageSettings: {
      topPage: {
        upcomingHeadline: {
          isDisplay: true,
          mainText: null,
          subText: null,
        },
        isDisplayTodaysEvent: true,
        isDisplayInfoArea: true,
        isDisplayDeliveryDisplayArea: false,
        isDisplayCatchCopy: false,
      },
      eventListPage: {
        /** -- 基本的にtrueで設定する -- */
        isDisplayEventDatetimeLabel: true,
        /** ------------------------- */
      },
      eventPage: {
        /** -- 基本的にtrueで設定する -- */
        isDisplayEventState: true,
        isDisplayEventTitle: true,
        isDisplayArtist: true,
        isDisplayShareButton: true,
        /** ------------------------- */
        linkInPage: {
          color: "#fff",
          link01: {
            isDisplay: true,
            text: i18nextT(
              "hosting.templates.event1.event.linkInEvent.link01.text"
            ),
          },
          link02: {
            isDisplay: true,
            text: i18nextT(
              "hosting.templates.event1.event.linkInEvent.link02.text"
            ),
          },
          link03: {
            isDisplay: true,
            text: i18nextT(
              "hosting.templates.event1.event.linkInEvent.link03.text"
            ),
          },
          link04: {
            isDisplay: true,
            text: i18nextT(
              "hosting.templates.event1.event.linkInEvent.link04.text"
            ),
          },
          link05: {
            isDisplay: true,
            text: i18nextT(
              "hosting.templates.event1.event.linkInEvent.link05.text"
            ),
          },
        },
        artistInfo: {
          isDisplayArtistStateLabel: true,
          headline: {
            isDisplay: true,
            text: i18nextT(
              "hosting.templates.event1.event.artistInfo.heading.text"
            ),
            subText: i18nextT(
              "hosting.templates.event1.event.artistInfo.heading.subText"
            ),
          },
        },
        purchaseButton: {
          path: null,
        },
      },
      goodsPage: {
        /** -- 基本的にtrueで設定する -- */
        isDisplayEventTitle: true,
        isDisplayArtist: true,
        isDisplayGoodsInfo: true,
        /** ------------------------- */
      },
      streamingPage: {
        isDisplaySuperChatArea: true,
      },
      accountTicketPage: {
        /** -- 基本的にtrueで設定する -- */
        isDisplayEventTitle: true,
        isDisplayArtist: true,
        isDisplayShareButton: true,
        /** ------------------------- */
      },
    },
  };
};
